var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-footer"},[_c('p',{staticClass:"m-tit tc mb-10"},[_c('span',{staticClass:"mr-30"},[_vm._v("帮助")]),_c('span',{staticClass:"mr-30"},[_vm._v("隐私")]),_c('span',[_vm._v("条款")])])])
}]

export { render, staticRenderFns }